module.exports = __webpack_public_path__ + "img/raio.4bb21a13.svg";